// extracted by mini-css-extract-plugin
export var card = "_a8-1";
export var container = "_a8-0";